import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask2500To2599Service {

  constructor() { }
}
